import MenuItem from "@components/MenuItem"
import animation, { cubicBezier } from "@constants/animation"
import colors from "@constants/colors"
import { getIn } from "@utils/index"
import * as R from "ramda"
import React from "react"
import styled from "styled-components"

import { BreadcrumbButton, Headers } from "./common"
import { MenuLinkProps } from "./MobileMenu"

const openProps = `
  transform: translateX(0);
  transition: transform ${animation.medium} ${cubicBezier};
`
const Container = styled.div<{ isOpen?: boolean }>`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  transform: translateX(100%);
  transition: transform ${animation.medium} ${cubicBezier};
  will-change: transform;
  background-color: ${colors.offWhite};
  overflow: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 3;
  ${({ isOpen }) => (isOpen ? openProps : "")}
`

const overlayActiveProps = `
  opacity: 0.1
  transition: opacity ${animation.medium} ${cubicBezier};
`
const Overlay = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  will-change: opacity;
  opacity: 0;
  transition: opacity ${animation.kindaLong} ${cubicBezier};
  background-color: ${colors.black};
  pointer-events: none;
  z-index: 2;
  ${({ isVisible }) => (isVisible ? overlayActiveProps : "")}
`

const Items = styled.div`
  overflow: hidden;
`

interface MenuSubGroupProps {
  menuSubGroup?: string
  menuSubGroups?: Array<MenuLinkProps>
  onRequestClose?: () => void
}

const MenuSubGroup: React.FC<MenuSubGroupProps> = ({
  menuSubGroup,
  menuSubGroups,
  onRequestClose,
}) => {
  const [renderedGroup, setRenderedGroup] = React.useState<any>()

  React.useEffect(() => {
    if (!menuSubGroups) {
      return
    } else if (!renderedGroup) {
      setRenderedGroup(menuSubGroups[0])
      return
    }

    const selectedGroup = R.find(
      ({ label }) => label === menuSubGroup,
      menuSubGroups
    )

    if (selectedGroup) {
      setRenderedGroup(selectedGroup)
    }
  }, [menuSubGroup, menuSubGroups])

  const formatLink = ({ external, label, link }) => ({
    external,
    label,
    link,
  })

  const formattedLinks =
    (renderedGroup &&
      renderedGroup.items &&
      renderedGroup.items.map(formatLink)) ||
    []

  return (
    <>
      <Overlay isVisible={!!menuSubGroup} />
      <Container isOpen={!!menuSubGroup}>
        <Headers>
          <BreadcrumbButton
            label={getIn(renderedGroup, "label", "")}
            onClick={onRequestClose}
          />
        </Headers>
        <Items>
          {formattedLinks.map((props) => (
            <MenuItem key={props.label} {...props} />
          ))}
        </Items>
      </Container>
    </>
  )
}

export default MenuSubGroup
